import React, { Component } from "react";
import { connect } from "react-redux";
import { Parse } from "parse";
import BigCalendar from "react-big-calendar";
import styled from "styled-components";
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  message,
  Select,
  TimePicker,
  Row,
  List
} from "antd";

import ClientModal from "./clientModal";
import coaching from "../img/1.png";
import diet from "../img/diet.jpg";
import semaineTest from "../img/semaineTest.png";
import emptygym from "../img/emptygym.jpg";

import "moment/locale/fr";
import "./calendar.css";
import "../style.css"
import "react-big-calendar/lib/css/react-big-calendar.css";
const moment = require("moment-timezone");

moment.locale("fr");
moment().format("MMMM Do YYYY, h:mm,ss a");
BigCalendar.momentLocalizer(moment);

const FormItem = Form.Item;
const Option = Select.Option;

const Modalstyled = styled(Modal)`
  .ant-modal-content {
    width: 600px;
  }
`;

class MyCalendar extends Component {
  constructor(props) {
    super(props);
    //visible: modale visible ou pas
    //slotInfo: les infos du slot sur lequel l'utilisateur a cliqué (l'heure de début etc)
    //evenement: les infos de l'event sur lequel l'utilisateur a cliqué
    //startHour : 18 : 00
    //endHour : 19h : 00
    this.state = {
      visible: false,
      slotInfo: null,
      evenement: "",
      eventTitle: "",
      eventType: "",
      eventDesc: "",
      allDay: "false",
      startHour: "",
      endHour: "",
      startDate: "",
      teamEvent: [],
      privateEvent: [],
      dietEvent: [],
      semaineTest: [],
      indispo: [],
      coach: []
    };
  }

  componentDidMount() {
    this.professional =
      Parse.User.current().attributes.professional === true ? true : false;
    if (Parse.User.current().attributes.team !== undefined) {
      var ctx = this;
      var team = Parse.User.current().get("team");
      team.fetch().then(function(team) {
        let coach = team.get("coach");
        let diet = team.get("diet");
        ctx.setState({ coach: coach, diet: diet });
      });
      this.myQuery();
      this.semaineTestQuery();
    }
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    // You can also log the error to an error reporting service
    console.log("catch error : ", error);
    console.log("catch info : ", info);
  }

  /*
  Pour sauvegarder les valeurs qui ont été entrées dans le formulaire pour créer un event
  values : les valeurs du form
  */
  saveNewEvent = values => {
    this.setState({
      visible: false
    });
    var ctx = this;
    var startMerge =
      moment(this.state.startDate).format("YYYY-MM-DD") +
      " " +
      moment(this.state.startDate).format("HH:mm:ss");
    var startForParse = new Date(startMerge);
    var event = null;
    var Event = null;
    var ACL = new Parse.ACL();
    ACL.setPublicWriteAccess(false);
    ACL.setPublicReadAccess(true);

    if (values.eventType === "Cours en groupe") {
      Event = Parse.Object.extend("Event");
      event = new Event();
      event.set("team", Parse.User.current().get("team"));
      // console.log('USER in MyCalendar:', Parse.User);
      event.set("participantsId", [Parse.User.current().id]);
      // event.set("participantsName", [Parse.User.current().firstName + ' ' + Parse.User.current().lastName]);
      var relation = event.relation("participants");
      relation.add(Parse.User.current());
      event.set("participantsCount", 1);
      event.set("coach", this.state.coach);
      ACL.setWriteAccess(Parse.User.current().id, true);
      ACL.setReadAccess(Parse.User.current().id, true);
    } else if (values.eventType === "Cours individuel") {
      Event = Parse.Object.extend("PrivateEvent");
      event = new Event();
      event.set("accepted", false);
      event.set("user", Parse.User.current());
      event.set("coach", this.state.coach);

      ACL.setWriteAccess(Parse.User.current().id, true);
      ACL.setReadAccess(Parse.User.current().id, true);
      ACL.setWriteAccess(this.state.coach.id, true);
      ACL.setReadAccess(this.state.coach.id, true);
    } else if (values.eventType === "RDV diet") {
      if (!this.state.diet) {
        message.error("Aucun diet n'a été attribué à ta team !");
        return;
      }
      Event = Parse.Object.extend("DietEvent");
      event = new Event();
      event.set("accepted", false);
      event.set("user", Parse.User.current());
      //console.log("this.state.diet.id : ", this.state.diet.id);
      event.set("diet", this.state.diet);
      ACL.setWriteAccess(Parse.User.current().id, true);
      ACL.setReadAccess(Parse.User.current().id, true);
      ACL.setWriteAccess(this.state.diet.id, true);
      ACL.setReadAccess(this.state.diet.id, true);
    } else if (values.eventType === "Indispo") {
      Event = Parse.Object.extend("Indispo");
      event = new Event();
      event.set("coach", Parse.User.current());
      //console.log("this.state.diet.id : ", this.state.diet.id);
      event.set("team", Parse.User.current().get("team"));
      ACL.setWriteAccess(Parse.User.current().id, true);
      ACL.setReadAccess(Parse.User.current().id, true);
      var endDateMerge =
        moment(this.state.startDate).format("YYYY-MM-DD") +
        " " +
        moment(this.state.endHour)._i;
      var endDate = new Date(endDateMerge);
      event.set("endDate", endDate);
    }
    //console.log("event2 : ", event);
    event.setACL(ACL);
    event.set("eventType", values.eventType);
    event.set("startDate", startForParse);
    //event.set("eventTitle", values.eventTitle);
    //event.set("allDay", false);
    //event.set("eventDesc", values.eventDesc);
    event
      .save(null, {
        success: function(event) {
          return event;
          //var json = JSON.stringify(event);
          //var parsedEvent = JSON.parse(json);
          //ctx.props.eventToStore(parsedEvent);
        },
        error: function(event, error) {
          // error is a Parse.Error with an error code and message.
          message.error("Erreur : " + error.message);
        }
      })
      .then(async function(event) {
        if (event.className === "Event") {
          message.success("Cours crée ! ");
        } else if (event.className === "PrivateEvent") {
          message
            .success("Demande de cours particulier créée !")
            .then(() =>
              message.success(
                "Ton coach doit maintenant l'accepter pour valider le cours"
              )
            );
        } else if (event.className === "DietEvent") {
          message
            .success("Demande de rdv diet créée !")
            .then(() =>
              message.info(
                "Ton diet doit maintenant l'accepter pour valider le rendez-vous."
              )
            );
        }
        await ctx.myQuery();
        ctx.props.form.resetFields(["startHour", "startDate", "endHour"]);
        ctx.setState({ startDate: null });
      });
  };

  /* DELETE EVENT */
  deleteEvent = async () => {
    //console.log(this.state.evenement.objectId);
    await Parse.Cloud.run("deleteEvent", {
      eventId: this.state.evenement.objectId
    }).catch(function(error) {
      //console.log("error : ", error);
      message.error("Erreur : " + error.message);
      return;
    });
    await this.myQuery();
    message.info("Ce cours a bien été supprimé");
    this.setState({ evenement: null, visible: false });
  };

  /* DELETE PRIVATE EVENT */
  deletePrivateEvent = async () => {
    //console.log(this.state.evenement.objectId);
    await Parse.Cloud.run("deletePrivateEvent", {
      eventId: this.state.evenement.objectId
    });
    await this.myQuery();
    message.info("Cette demande de cours a bien été annulée");
    this.setState({ evenement: null, visible: false });
  };

  /* DELETE EVENT */
  deleteDietEvent = async () => {
    await Parse.Cloud.run("deleteDietEvent", {
      eventId: this.state.evenement.objectId
    });
    await this.myQuery();
    message.info("Cette demande de rdv a bien été annulée");
    this.setState({ evenement: null, visible: false });
  };

  /* DELETE EVENT */
  deleteIndispo = async () => {
    await Parse.Cloud.run("deleteIndispo", {
      eventId: this.state.evenement.objectId
    }).catch(function(error) {
      //console.log("error : ", error);
      message.error("Erreur : " + error.message);
      return;
    });
    await this.myQuery();
    message.info("Cette indisponibilité a bien été supprimée");
    this.setState({ evenement: null, visible: false });
  };

  /*fonction cloud pour qu'un coach accepte un cours particulier*/
  acceptEvent = async () => {
    var ctx = this;
    //console.log(ctx.state.evenement.objectId);
    Parse.Cloud.run("acceptEvent", {
      eventId: ctx.state.evenement.objectId
    }).then(function(response) {
      if (response === "-1") {
        message.error("Vous êtes déjà inscrit à ce cours");
      } else {
        message.success("Vous avez bien accepté ce cours !");
      }
    });
    await this.myQuery();
    ctx.setState({ evenement: null, visible: false });
  };

  /*fonction cloud pour qu'un diet accepte un rdv*/
  acceptDietEvent = async () => {
    var ctx = this;
    //console.log(ctx.state.evenement.objectId);
    await Parse.Cloud.run("acceptDietEvent", {
      eventId: ctx.state.evenement.objectId
    });
    await this.myQuery();
    message.success("Vous avez bien accepté ce rendez-vous !");
    ctx.setState({ evenement: null, visible: false });
  };

  /*fonction cloud pour rejoindre un evenement*/
  joinEvent = async () => {
    var ctx = this;
    let user = Parse.User.current();
    let expiAbo = user.attributes.expirationAbo;
    let now = new Date();

    if (now < expiAbo) {
      try {
        await Parse.Cloud.run("saveParticipant", {
          eventId: ctx.state.evenement.objectId
        });
        await ctx.myQuery();
        message.success("Vous êtes bien inscrit au cours !");

        ctx.setState({ evenement: null, visible: false });
      } catch (error) {
        message.error("Erreur : " + error.message);
        ctx.setState({ evenement: null, visible: false });
      }
    } else {
      this.handleCancel();
      message.error(
        "Votre abonnement a expiré ! Vous devez vous réinscrire pour participer aux cours. "
      );
    }
  };

  /* DELETE Participant */
  deleteParticipant = async () => {
    await Parse.Cloud.run("deleteParticipant", {
      eventId: this.state.evenement.objectId
    });
    await this.myQuery();
    message.info("Vous avez bien quitté le cours");
    this.setState({ evenement: null, visible: false });
  };
  /*
  HandleSubmit : permet l'appel à la fonction saveNewEvent ainsi que des vérifications d'heure
*/
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((error, values) => {

      if (error) {
        message.error("Certains champs ne sont pas correctement remplis");
      } else if (
        this.state.eventType === "Cours en groupe" &&
        this.state.startHour.localeCompare("19:30") >= 0
      ) {
        this.setState({
          startHour: "",
          endHour: "",
          startDate: ""
        });
        this.props.form.resetFields(["startHour", "endHour"]);
        message.error("Vous ne pouvez pas créer un cours en groupe après 19h.");
      } else if (
        this.state.eventType === "Cours en groupe" &&
        this.state.startHour.localeCompare("09:00") <= -1
      ) {
        this.setState({
          startHour: "",
          endHour: "",
          startDate: ""
        });
        this.props.form.resetFields(["startHour", "endHour"]);
        message.error("Vous ne pouvez pas créer un cours en groupe avant 9h.");
      } else {
        this.saveNewEvent(values);
      }
    });
  };

  /*première query pour récupérer tous les events qui sont dans la classe Event. On les récupère par team, et seuls sont fetchs les events après now()*/
  /*seconde query pour récupérer tous les events persos*/
  myQuery() {
    var ctx = this;
    var monthAgo = moment().subtract(1, 'months')
    var query = new Parse.Query("Event");
    query.include("team");
    query.include("participants");
    query.equalTo("team", Parse.User.current().get("team"));
    query.greaterThan("startDate", monthAgo._d);
    query.find().then(function(results) {
      results.forEach((evt) =>{
          if(evt.particpantsName === undefined) evt.participantsName = [];
          // console.log(evt);

          var rel = evt.relation('participants');
          return rel
            .query()
            .find()
            .then(function(participants) {
              return participants.forEach((participant) => {
                const data = participant.attributes;
                const fullname = `${data.firstName.trim()} ${data.lastName.trim()}`; 
                // console.log('participant name', fullname);
                evt.participantsName.push(fullname);
              })
            });
        });

        // return results;
        // console.log('my results', results);
        ctx.setState({ teamEvent: results });
      });

    var query2 = new Parse.Query("PrivateEvent");
    query2.greaterThan("startDate", monthAgo._d);
    //rajouter filtre pour afficher seulement private event de l'user ?
    //faire une query spécifique pour pro/coach et user lambda
    query2.include("user");
    query2.find().then(function(results) {
      ctx.setState({ privateEvent: results });
    });
    var query3 = new Parse.Query("DietEvent");
    query3.greaterThan("startDate", monthAgo._d);
    query3.include("user");
    query3.find().then(function(results) {
      ctx.setState({ dietEvent: results });
    });
    var query4 = new Parse.Query("Indispo");
    query4.greaterThan("startDate", monthAgo._d);
    query4.equalTo("team", Parse.User.current().get("team"));
    //query4.include("user");
    query4.find().then(function(results) {
      ctx.setState({ indispo: results });
    });
  }

  getFirstDayOfTheWeek = (date) => {
    date = new Date(date);
    var day = date.getDay(),
        diff = date.getDate() - day + (day == 0 ? -6:1); // adjust when day is sunday
    return new Date(date.setDate(diff));
  }

  async semaineTestQuery() {
    var semaineTestQuery = new Parse.Query("SemaineTest");
    var now = new Date();
    var monday = this.getFirstDayOfTheWeek(now);
    monday.setHours(0,0,0);
    semaineTestQuery.greaterThan("start", monday);
    let results = await semaineTestQuery.find();
    this.setState({ semaineTest: results });
  }

  /*récupérer les evenement de la team pour l'afficher sur l'agenda */
  recupAllEvents() {
    //console.log("this.state.privateEvent : ", this.state.privateEvent);
    var allEvents = [];
    var teamEvent = this.state.teamEvent;
    var privateEvent = this.state.privateEvent;
    var dietEvent = this.state.dietEvent;
    var semaineTest = this.state.semaineTest;
    var indispo = this.state.indispo;

    var endDate = "";
    var intermEndDate = "";
    // console.log('TeamEvents:', teamEvent);
    for (var i = 0; i < teamEvent.length; i++) {
      allEvents[i] = {};
      intermEndDate =
        moment(teamEvent[i].attributes.startDate).format("YYYY-MM-DD") +
        " " +
        moment(teamEvent[i].attributes.startDate)
          .add(1, "hours")
          .format("HH:mm:ss");
      endDate = new Date(intermEndDate);
      allEvents[i].endDate = endDate;
      allEvents[i].eventTitle = teamEvent[i].attributes.eventTitle;
      allEvents[i].allDay = false;
      allEvents[i].objectId = teamEvent[i].id;
      allEvents[i].eventDesc = teamEvent[i].attributes.eventDesc;
      if (teamEvent[i].attributes.eventTitle !== undefined) {
        allEvents[i].title = `${teamEvent[i].attributes.eventTitle} (${
          teamEvent[i].attributes.participantsCount
        }/10 participants)`;
      } else
        allEvents[i].title = `Urban Fitness (${
          teamEvent[i].attributes.participantsCount
        }/10 participants)`;
      allEvents[i].eventType = teamEvent[i].attributes.eventType;
      allEvents[i].startDate = teamEvent[i].attributes.startDate;
      allEvents[i].participantsCount =
        teamEvent[i].attributes.participantsCount;
      if (teamEvent[i].attributes.participantsId !== undefined) {
        allEvents[i].participantsId = teamEvent[i].attributes.participantsId;
      } else {
        allEvents[i].participantsId = null;
      }
      if (teamEvent[i].participantsName !== undefined) {
        allEvents[i].participantsName = teamEvent[i].participantsName;
      } else {
        allEvents[i].participantsName = null;
      }

      allEvents[i].avatar = teamEvent[i].attributes.team.attributes.avatar._url;
    }
    ++i;
    for (var j = 0; j < privateEvent.length; j++) {
      if (
        Parse.User.current().id === privateEvent[j].attributes.coach.id ||
        Parse.User.current().id === privateEvent[j].attributes.user.id
      ) {
        allEvents[i] = {};
        intermEndDate =
          moment(privateEvent[j].attributes.startDate).format("YYYY-MM-DD") +
          " " +
          moment(privateEvent[j].attributes.startDate)
            .add(1, "hours")
            .format("HH:mm:ss");
        endDate = new Date(intermEndDate);
        allEvents[i].endDate = endDate;

        allEvents[i].allDay = false;
        allEvents[i].objectId = privateEvent[j].id;
        allEvents[i].eventDesc = privateEvent[j].attributes.eventDesc;
        if (privateEvent[j].attributes.accepted !== true) {
          allEvents[i].title = "Demande de cours individuel";
        } else allEvents[i].title = "Cours individuel";
        allEvents[i].startDate = privateEvent[j].attributes.startDate;
        allEvents[i].participantsCount =
          privateEvent[j].attributes.participantsCount;
        if (privateEvent[j].attributes.participantsId !== undefined) {
          allEvents[i].participantsId =
            privateEvent[j].attributes.participantsId;
        } else {
          allEvents[i].participantsId = null;
        }
        allEvents[i].accepted = privateEvent[j].attributes.accepted;
        allEvents[i].user = privateEvent[j].attributes.user.attributes.nickName;
        allEvents[i].eventType = privateEvent[j].attributes.eventType;
        allEvents[i].eventTitle = privateEvent[j].attributes.eventTitle;
        ++i;
      }
    }

    for (var k = 0; k < dietEvent.length; k++) {
      if (
        Parse.User.current().id === dietEvent[k].attributes.diet.id ||
        Parse.User.current().id === dietEvent[k].attributes.user.id
      ) {
        allEvents[i] = {};
        intermEndDate =
          moment(dietEvent[k].attributes.startDate).format("YYYY-MM-DD") +
          " " +
          moment(dietEvent[k].attributes.startDate)
            .add(30, "minutes")
            .format("HH:mm:ss");
        endDate = new Date(intermEndDate);
        allEvents[i].endDate = endDate;
        allEvents[i].objectId = dietEvent[k].id;
        if (dietEvent[k].attributes.accepted !== true) {
          allEvents[i].title = "Demande de rdv diet";
        } else allEvents[i].title = "Rappel RDV diet";
        allEvents[i].startDate = dietEvent[k].attributes.startDate;
        allEvents[i].accepted = dietEvent[k].attributes.accepted;
        allEvents[i].user = dietEvent[k].attributes.user.attributes.nickName;
        allEvents[i].eventType = dietEvent[k].attributes.eventType;
        ++i;
      }
    }

    for (var t = 0; t < semaineTest.length; t++) {
      allEvents[i] = {};
      //console.log("semaineTest: ", semaineTest);
      //  console.log("semaineTest[t]: ", semaineTest[t]);
      allEvents[i].endDate = semaineTest[t].attributes.end;
      allEvents[i].startDate = semaineTest[t].attributes.start;
      allEvents[i].allDay = true;
      allEvents[i].title = "Semaine Test";

      //  allEvents[i].eventType = semaineTest[t].attributes.eventType;
      ++i;
    }

    for (var x = 0; x < indispo.length; x++) {
      allEvents[i] = {};
      //console.log("semaineTest: ", semaineTest);
      //  console.log("semaineTest[t]: ", semaineTest[t]);
      allEvents[i].startDate = indispo[x].attributes.startDate;
      allEvents[i].endDate = indispo[x].attributes.endDate;
      allEvents[i].eventType = indispo[x].attributes.eventType;
      allEvents[i].objectId = indispo[x].id;
      allEvents[i].title = "Indisponibilité du coach";

      ++i;
    }
    //console.log("allEvents : ", allEvents);
    return allEvents;
  }

  handleOk = e => {
    this.setState({
      visible: false
    });
  };

  handleCancel = e => {
    this.setState(
      {
        visible: false,
        startHour: "",
        endHour: "",
        startDate: ""
      },
      () => this.props.form.resetFields(["startHour", "startDate", "endHour"])
    );
  };

  //OnChange //
  onChangeEventType = e => {
    //console.log("this:", this);
    //console.log("e:", e);
    //console.log("state: ", this.state.eventType);
    if (!e) return;

    this.setState({ eventType: e });
    this.props.form.setFieldsValue({ eventType: e });
  };

  setEventTypeChild = e => {
    this.setState({ eventType: e });
  };
  onChangeStartDate = e => {
    this.setState({ startDate: e });
    this.props.form.setFieldsValue({ startDate: e });
  };

  onChangeStartHour = e => {
    var starthour = moment(e).format("HH:mm");
    //var startDate = th
    this.setState({startDate: e})
    this.setState({ startHour: starthour });
    var endhour = "";
    if (this.state.eventType === ("Cours en groupe" || "Cours individuel")) {
      endhour = moment(e)
        .add(1, "hours")
        .format("HH:mm");
    } else if (this.state.eventType === "RDV Diet") {
      endhour = moment(e)
        .add(30, "minutes")
        .format("HH:mm");
    } else if (this.state.eventType === "Indispo") {
      return;
    } else {
      endhour = moment(e)
        .add(1, "hours")
        .format("HH:mm");
    }
    this.setState({ endHour: endhour });
  };

  onChangeEndHour = e => {
    var endHour = moment(e).format("HH:mm:ss");
    this.setState({ endHour: endHour });
  };

  onChangeEventTitle = e => {
    this.setState({ eventTitle: e });
    this.props.form.setFieldsValue({ eventTitle: e });
  };

  onChangeEventDesc = e => {
    this.setState({ eventDesc: e });
    this.props.form.setFieldsValue({ eventDesc: e });
  };

  isEndTimeDisabled = () => {
    if (this.state.eventType === "Indispo") {
      return false;
    } else return true;
  };

  disabledTime() {
    //0, 1, 2, 3, 4, 5, 6, 7, 8, 20, 21, 22, 23
    //9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19
    var arrayHours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 22, 23];
    return arrayHours;
  }
  disabledDate = current => {
    var a = moment().subtract(1, "day");
    // Can not select days before today and today
    return current && current < a;
  };

  /*Lorsque l'utilisateur clique sur un slot qui est totalement libre
  on met la modale en mode visible, on récupère les infos de là où on a cliqué (slotInfo)
  et on met évènement à null
  */
  changeVisible(slotInfo) {
    if (slotInfo.action === "click" || slotInfo.action === "select") {
      var slotinfo = moment(slotInfo.start).format("HH");

      if (
        slotinfo.localeCompare("09") === 0 ||
        (slotinfo.localeCompare("09") === 1 &&
          slotinfo.localeCompare("22") !== 0)
      ) {
        this.setState({
          visible: true,
          slotInfo: slotInfo,
          startHour: moment(slotInfo.start).format("HH:mm"),
          endHour: moment(slotInfo.start)
            .add(1, "hours")
            .format("HH:mm"),
          startDate: slotInfo.start,
          evenement: null
        });
      }
    }
  }

  /*Lorsque l'utilisateur clique sur un slot qui est totalement libre
  on met la modale en mode visible, on récupère les infos de là où on a cliqué ( évènement )
  et on met slotInfo à null
  */
  changeModalEvent(events) {
    this.setState({
      visible: true,
      evenement: events,
      slotInfo: null
    });
  }

  /*on choisit quels types d'event seront affichés si l'utilisateur est un pro ou pas, si c'est la semaine test -> à faire*/
  displayEventType() {
    let professional =
      Parse.User.current().attributes.professional === undefined ? false : true;

    if (professional === false /*&& que ce n'est pas la semaine test)*/) {
      return (
        <Select onChange={this.onChangeEventType}>
          <Option value="Cours en groupe">
            Réserver un créneau de cours en groupe
          </Option>
          <Option value="Cours individuel">Demande de cours individuel</Option>
          <Option value="RDV diet">Demande de rendez-vous diet</Option>
        </Select>
      );
    } else if (
      professional === true &&
      Parse.User.current().attributes.job === "Coach"
    ) {
      if (this.state.eventType === "") {
        this.setState({ eventType: "Indispo" });
      }
      return (
        <Select onChange={this.onChangeEventType}>
          <Option value="Indispo">Indisponibilité du coach</Option>
        </Select>
      );
    } else if (
      professional === true &&
      Parse.User.current().attributes.job === "Diet"
    ) {
      return (
        <Select onChange={this.onChangeEventType}>
          <Option value="RDV Diet">Rendez-vous Diet</Option>
        </Select>
      );
    }
  }

  displayEventName() {
    if (
      Parse.User.current().attributes.professional ===
      false /*&& que ce n'est pas la semaine test)*/
    ) {
      return "";
    } else if (Parse.User.current().attributes.professional === true) {
      return <Input />;
    }
  }

  displayEventDesc() {
    if (
      Parse.User.current().attributes.professional ===
      false /*&& que ce n'est pas la semaine test)*/
    ) {
      return "";
    } else if (Parse.User.current().attributes.professional === true) {
      return <Input />;
    }
  }

  getEventDesc() {
    if (this.state.evenement.eventDesc !== undefined)
      return `Description du cours : ${this.state.evenement.eventDesc}`;
  }

  /* Obtenir le nombre de participants à une session.  */
  getParticipantsCount() {
    //console.log("event : ", this.state.evenement);
    if (this.state.evenement.title === "Semaine Test") {
      return `C'est la semaine test ! Pas de coach, vous devez vous organiser entre membres de l'équipe pour vos entraînements de la semaine.
      Vous pouvez utiliser le chat pour vous rassembler et faire du sport ensemble.`;
    } else if (this.state.evenement.eventType === "Cours individuel") {
      if (this.state.evenement.accepted !== true) {
        return null;
      } else
        return `Cours particulier réservé par : ${this.state.evenement.user} `;
    } else if (this.state.evenement.eventType === "RDV diet") {
      if (this.state.evenement.accepted !== true) {
        return null;
      } else return `RDV diet réservé par : ${this.state.evenement.user} `;
    } else if (this.state.evenement.participantsCount !== undefined) {
      return `Nombre: ${
        this.state.evenement.participantsCount
      }/10`;
    } else if (this.state.evenement.eventType === "Indispo") {
      return `Votre coach n'est pas disponible. Vous ne pouvez pas réserver de cours collectifs ou individuels sur ce créneau !`;
    } else return `Nombre de participants : 0/10`;
  }

  getImgSource() {
    if (this.state.evenement.avatar) return this.state.evenement.avatar;
    else if (this.state.evenement.eventType === "RDV diet") return diet;
    else if (this.state.evenement.title === "Semaine Test") return semaineTest;
    else if (this.state.evenement.eventType === "Indispo") return emptygym;
    else return coaching;
  }

  getButton() {
    //console.log("event : ", this.state.evenement.eventType );
    //console.log('professional : ', Parse.User.current().attributes.professional === true)
    /*  console.log(
      "this.state.evenement.participantsId : ",
      this.state.evenement.participantsId
    );
    */
    //si semaine test, pas de bouton
    if (this.state.evenement.title === "Semaine Test") {
      return null;
    }
    if (Parse.User.current().attributes.professional === true) {
      if (this.state.evenement.eventType === "Indispo") {
        return (
          <Row type="flex" justify="center" align="middle">
            <Button
              type="primary"
              onClick={this.deleteIndispo}
              style={{ marginTop: "10px" }}
            >
              Annuler mon indisponibilité
            </Button>
          </Row>
        );
      }
      if (this.state.evenement.eventType === "RDV diet") {
        if (this.state.evenement.accepted !== true) {
          return (
            <div>
              <Row type="flex" justify="center" align="middle">
                <Button
                  type="primary"
                  onClick={this.acceptDietEvent}
                  style={{ marginTop: "10px" }}
                >
                  Accepter le rendez-vous
                </Button>
              </Row>
              <Row type="flex" justify="center" align="middle">
                <Button
                  onClick={this.deleteDietEvent}
                  style={{ marginTop: "10px" }}
                >
                  Refuser le rendez-vous
                </Button>
              </Row>
            </div>
          );
        } else {
          return (
            <Row type="flex" justify="center" align="middle">
              <Button
                type="primary"
                onClick={this.deleteDietEvent}
                style={{ marginTop: "10px" }}
              >
                Annuler la demande de rendez-vous
              </Button>
            </Row>
          );
        }
      }
      // is the event private or group?
      else if (
        this.state.evenement.eventType === "Cours individuel" &&
        this.state.evenement.accepted === false
      ) {
        return (
          <div>
            <Row type="flex" justify="center" align="middle">
              <Button
                type="primary"
                onClick={this.acceptEvent}
                style={{ marginTop: "10px" }}
              >
                Accepter le cours particuler
              </Button>
            </Row>
            <Row type="flex" justify="center" align="middle">
              <Button
                onClick={this.deletePrivateEvent}
                style={{ marginTop: "10px" }}
              >
                Refuser le cours particuler
              </Button>
            </Row>
          </div>
        );
      }
      //  console.log("includes ? ",this.state.evenement.participantsId.includes(Parse.User.current().id))
      if (
        this.state.evenement.eventType === "Cours individuel" &&
        this.state.evenement.accepted === true
      ) {
        return (
          <Row type="flex" justify="center" align="middle">
            <Button
              type="primary"
              onClick={this.deletePrivateEvent}
              style={{ marginTop: "10px" }}
            >
              Annuler la demande de cours particulier
            </Button>
          </Row>
        );
      } else {
        return (
          <Row type="flex" justify="center" align="middle">
            <Button
              type="primary"
              onClick={this.deleteEvent}
              style={{ marginTop: "10px" }}
            >
              Annuler le cours collectif
            </Button>
          </Row>
        );
      }
    } //on passe aux users normaux
    else if (this.state.evenement.eventType === "Cours individuel") {
      return (
        <Row type="flex" justify="center" align="middle">
          <Button
            type="primary"
            onClick={this.deletePrivateEvent}
            style={{ marginTop: "10px" }}
          >
            Annuler la demande de cours particulier
          </Button>
        </Row>
      );
    } else if (this.state.evenement.eventType === "RDV diet") {
      return (
        <Row type="flex" justify="center" align="middle">
          <Button
            type="primary"
            onClick={this.deleteDietEvent}
            style={{ marginTop: "10px" }}
          >
            Annuler la demande de rendez-vous
          </Button>
        </Row>
      );
    } else if (this.state.evenement.eventType === "Indispo") {
      return null;
    } else if (
      this.state.evenement.participantsId &&
      this.state.evenement.participantsId.includes(Parse.User.current().id)
    ) {
      return (
        <Row type="flex" justify="center" align="middle">
          <Button
            type="primary"
            onClick={this.deleteParticipant}
            style={{ marginTop: "10px" }}
          >
            Quitter le cours
          </Button>
        </Row>
      );
    } else
      return (
        <Row type="flex" justify="center" align="middle">
          <Button
            type="primary"
            onClick={this.joinEvent}
            style={{ marginTop: "10px" }}
          >
            Rejoindre
          </Button>
        </Row>
      );
  }
  /*si slotinfo null -> utilisateur a cliqué sur un évènement donc slotinfo null
  si evenement null -> utilisateur a cliqué sur un slot dispo donc event null
  on affiche l'intérieur de la modale différement en fonciton des valeurs de slotinfo et evenement */
  chooseModal() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    };

    const dateFormat = "DD/MM/YYYY";
    const dateConfig = {
      rules: [
        {
          type: "object",
          required: true,
          message: "Merci d'indiquer la date"
        }
      ],
      initialValue: moment(this.state.startDate)
    };
    const format = "HH:mm";
    const { getFieldDecorator } = this.props.form;
    var initialValue = this.state.endHour;
    let selectDefaultValue;

    //select default Value as string
    if (Parse.User.current().attributes.professional !== true)
      selectDefaultValue = "Cours en groupe";
    else {
      if (Parse.User.current().attributes.job === "Coach")
        selectDefaultValue = "Indispo";
      else selectDefaultValue = "RDV diet";
    }
    //console.log("professional : ", this.professional);
    if (this.state.slotInfo !== null && this.professional === true) {
      return (
        <Modalstyled
          title="Créer un cours"
          visible={this.state.visible}
          onCancel={this.handleCancel}
          onOk={this.handleOk}
          footer={null}
        >
          <Form onSubmit={this.handleSubmit}>
            <FormItem {...formItemLayout} label="Type du cours">
              {getFieldDecorator("eventType", {
                rules: [
                  {
                    required: true,
                    message: "Veuillez spécifier le type de cours"
                  }
                ],
                initialValue: selectDefaultValue,
                onChange: this.props.onChangeEventType
              })(this.displayEventType())}
            </FormItem>
            <FormItem {...formItemLayout} label="Date du cours">
              {getFieldDecorator("startDate", dateConfig)(
                <DatePicker
                  disabledDate={this.disabledDate}
                  style={{ width: 200 }}
                  format={dateFormat}
                />
              )}
            </FormItem>
            <FormItem {...formItemLayout} label="Heure de début">
              {getFieldDecorator("startHour", {
                rules: [
                  {
                    required: true,
                    message: "Merci d'indiquer une heure de début"
                  }
                ],
                initialValue: moment(this.state.slotInfo.start, format)
              })(
                <TimePicker
                  format="HH:mm"
                  disabledHours={this.disabledTime}
                  minuteStep={15}
                  clearText="Supprimer"
                  placeholder="Heure"
                  onChange={this.onChangeStartHour}
                />
              )}
            </FormItem>
            <FormItem {...formItemLayout} label="Heure de fin">
              {getFieldDecorator("endHour", {
                rules: [
                  {
                    required: false,
                    message: "Merci d'indiquer une heure de fin"
                  }
                ],
                initialValue: moment(initialValue, format)
              })(
                <TimePicker
                  format="HH:mm"
                  minuteStep={15}
                  onChange={this.onChangeEndHour}
                  disabled={this.isEndTimeDisabled()}
                />
              )}
            </FormItem>
            {/*
            {
              <FormItem {...formItemLayout} label="Nom du cours">
                {getFieldDecorator("eventTitle", {
                  rules: [
                    {
                      //required: this.state.professional,
                      message: "Veuillez spécifier le titre du cours"
                    }
                  ],
                  onChange: this.props.onChangeEventTitle
                })(this.displayEventName())}
              </FormItem>
            }
            <FormItem {...formItemLayout} label="Description du cours">
              {getFieldDecorator("eventDesc", {
                rules: [
                  {
                    required: true,
                    message: "Veuillez spécifier une description pour le cours"
                  }
                ],
                onChange: this.props.onChangeEventDesc
              })(this.displayEventDesc())}
            </FormItem>
*/}
            <FormItem>
              <Button
                style={{ float: "right" }}
                type="primary"
                htmlType="submit"
              >
                Créer
              </Button>
            </FormItem>
          </Form>
        </Modalstyled>
      );
    } else if (this.state.slotInfo !== null && this.professional !== true) {

      return (
        <ClientModal
          handleCancel={this.handleCancel}
          saveNewEvent={this.saveNewEvent}
          handleOk={this.handleOk}
          onChangeStartHour={this.onChangeStartHour}
          startDate={this.state.startDate}
          endHour={this.state.endHour}
          setEventTypeChild={this.setEventTypeChild}
          visible={this.state.visible}
        />
      );
      /*
      console.log("arrivée Form 2");
      console.log("pro: ", this.professional);

      return (
        <Modalstyled
          title="Créer un cours"
          visible={this.state.visible}
          onCancel={this.handleCancel}
          onOk={this.handleOk}
          footer={null}
        >
          <Form onSubmit={this.handleSubmit}>
            <FormItem {...formItemLayout} label="Type du cours">
              {getFieldDecorator("eventType", {
                rules: [
                  {
                    required: true,
                    message: "Veuillez spécifier le type de cours"
                  }
                ],
                initialValue: selectDefaultValue,
                onChange: this.props.onChangeEventType
              })(this.displayEventType())}
            </FormItem>
            <FormItem {...formItemLayout} label="Date du cours">
              {getFieldDecorator("startDate", dateConfig)(
                <DatePicker
                  disabledDate={this.disabledDate}
                  style={{ width: 200 }}
                  format={dateFormat}
                />
              )}
            </FormItem>
            <FormItem {...formItemLayout} label="Heure de début">
              {getFieldDecorator("startHour", {
                rules: [
                  {
                    required: true,
                    message: "Merci d'indiquer une heure de début"
                  }
                ],
                initialValue: moment(this.state.slotInfo.start, format)
              })(
                <TimePicker
                  format="HH:mm"
                  disabledHours={this.disabledTime}
                  minuteStep={30}
                  clearText="Supprimer"
                  placeholder="Heure"
                  onChange={this.onChangeStartHour}
                />
              )}
            </FormItem>
            <FormItem {...formItemLayout} label="Heure de fin">
              {getFieldDecorator("endHour", {
                rules: [
                  {
                    required: false,
                    message: "Merci d'indiquer une heure de fin"
                  }
                ],
                initialValue: moment(initialValue, format)
              })(<TimePicker format="HH:mm" minuteStep={30} disabled={true} />)}
            </FormItem>
            <FormItem>
              <Row type="flex" justify="center">
                <Button type="primary" htmlType="submit">
                  Créer
                </Button>
              </Row>
            </FormItem>
          </Form>
        </Modalstyled>
      );

      */
    } else if (this.state.evenement !== null) {
      return (
        <Modal
          title={this.state.evenement.title}
          visible={this.state.visible}
          onOk={this.handleOk}
          footer={null}
          onCancel={this.handleCancel}
          style={{ width: "100%", height: "100%" }}
        >
          {/* {console.log(this.state.evenement.participantsName)} */}
          { this.state.evenement && this.state.evenement.participantsName && (
            <div>
              <p>Participants:</p>
              <ul>
                {
                  this.state.evenement.participantsName.map((name) => (<li key={name}>{name}</li>))  
                }
              </ul>
            </div>
          )}
          <br />
          <div> {this.getEventDesc()}</div>
          <br />
          <div> {this.getParticipantsCount()} </div>
          {this.getButton()}
        </Modal>
      );
    }
  }

  eventStyleGetter = (event, start, end, isVisible) => {
    //console.log("EVENT : ", event);
    //  console.log("EVENTYPE : ", event.eventType);
    let style;
    let backgroundColor;

    if (event.eventType === "Cours individuel") {
      if (event.accepted === true) {
        backgroundColor = "#5DFDCB"; //A5FFD6
        style = {
          backgroundColor: backgroundColor,
          borderColor: backgroundColor,
          color: "black",
          fontSize: "80%"
        };
      } else {
        backgroundColor = "#94C7D1";
        style = {
          backgroundColor: backgroundColor,
          borderColor: backgroundColor,
          color: "black",
          fontSize: "80%"
        };
      }
    } else if (event.eventType === "Cours en groupe") {
      backgroundColor = "#FFE897";
      style = {
        backgroundColor: backgroundColor,
        borderColor: backgroundColor,
        color: "black",
        fontSize: "80%"
      };
    } else if (event.eventType === "RDV diet") {
      backgroundColor = "#60992D";
      style = {
        backgroundColor: backgroundColor,
        borderColor: backgroundColor,
        color: "white",
        fontSize: "80%"
      };
    } else if (event.eventType === "Indispo") {
      backgroundColor = "#F15152";
      style = {
        backgroundColor: backgroundColor,
        borderColor: backgroundColor,
        color: "white",
        fontSize: "100%"
      };
    } //else, on est sur une semaine test
    else {
      backgroundColor = "#0000FE";
      style = {
        backgroundColor: backgroundColor,
        borderColor: backgroundColor,
        color: "white",
        fontSize: "100%",
        padding: "20px"
      };
    }
    return {
      style: style
    };
  };

  render() {
    var ctx = this;
    const recupAllEvents = ctx.recupAllEvents();
    // console.log("recup all events : ", recupAllEvents);

    const messages = {
      allDay: "Journée",
      previous: "Précédent",
      next: "Suivant",
      today: "Aujourd'hui",
      month: "Mois",
      week: "Semaine pleine",
      work_week: "Semaine",
      day: "Jour",
      agenda: "Agenda",
      date: "Date",
      time: "Heure",
      event: "événement",
      showMore: total => `+ ${total} événement(s) supplémentaire(s)`
    };
    return (
      <div>
        <BigCalendar
          selectable={"ignoreEvents"}
          messages={messages}
          min={new Date(2017, 10, 0, 8, 0, 0)}
          max={new Date(2017, 10, 0, 22, 0, 0)}
          culture="fr"
          localizer={moment}
          events={recupAllEvents}
          defaultView={"work_week"}
          views={["day", "work_week"]}
          eventPropGetter={this.eventStyleGetter}
          startAccessor="startDate"
          allDayAccessor="allDay"
          showMultiDayTimes={true}
          endAccessor="endDate"
          onSelectSlot={slotInfo => {
            this.changeVisible(slotInfo);
          }}
          onSelectEvent={event => {
            this.changeModalEvent(event);
          }}
        />
        {this.chooseModal()}
      </div>
    );
  }
}

const mapStateToProps = globalReducers => globalReducers;
const connectedMyCalendar = Form.create()(MyCalendar);
export default connect(
  mapStateToProps,
  null
)(connectedMyCalendar);
